import { Tooltip } from "antd";
import React, { Component } from "react";

export default class StepperTemplate3 extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.isLast = this.isLast.bind(this);
    this.activeFunc = this.activeFunc.bind(this);
    this.completedFunc = this.completedFunc.bind(this);
    this.stepperFunc = this.stepperFunc.bind(this);
    this.titleColor = this.titleColor.bind(this);
    this.backgroundColor = this.backgroundColor.bind(this);
  }

  isLast(index) {
    return index === this.props.steps.length - 1;
  }

  stepperFunc(index, ele) {
    if (
      !this.isLast(index) &&
      !this.props.backNotAllowed
      // this.completedFunc(index)
    ) {
      ele && ele.onClick();
    }
  }

  activeFunc(index) {
    return (
      !(this.props.disabledSteps || []).includes(index) &&
      index === this.props.activeStep
    );
  }

  completedFunc(index) {
    return (
      !(this.props.disabledSteps || []).includes(index) &&
      index < this.props.activeStep
    );
  }

  titleColor(i) {
    return this.activeFunc(i)
      ? this.props.activeTitleColor
      : this.completedFunc(i)
        ? this.props.completeTitleColor
        : this.props.defaultTitleColor;
  }

  backgroundColor(i) {
    return this.completedFunc(i)
      ? this.props.completeColor
      : this.activeFunc(i)
        ? this.props.activeColor
        : this.props.defaultColor;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activeStep !== this.props.activeStep) {
      if (this.scrollRef.current) {
        if (
          (this.props.activeStep == 4 && this.props.steps.length > 5) ||
          (this.props.activeStep == 6 && this.props.steps.length > 5)
        ) {
          this.scrollRef.current.scrollTo({
            left: this.scrollRef.current.scrollWidth,
            behavior: "smooth",
          });
        }
      }
    }
  }

  render() {
    return (
      <div
        className={`stepper-template3 ${
          this.props.isVertical2 ? "vertical-2" : ""
        } ${this.props.arrowType ? "arrow-type" : "vertical"}`}
        ref={this.scrollRef}
      >
        <div
          className={`inner-template ${
            this.props.isVertical2 && this.props.steps.length > 5
              ? "scroll-stepper-width"
              : ""
          } ${
            this.props.steps.length > 5 &&
            this.props.arrowType &&
            !this.props.arrowType2
              ? "scroll-stepper-width"
              : ""
          } ${this.props.isVertical2 && this.props.steps.length == 4 ? 'three' : ''} ${
            this.props.steps.length == 4 && this.props.arrowType
              ? "three"
              : this.props.steps.length == 3 && this.props.arrowType
                ? "two"
                : ""
          }`}
        >
          {this.props.steps.map((ele, i) => {
            return (
              <React.Fragment key={i}>
                {this.props.arrowType2 ? (
                  <Tooltip placement="bottom" title={ele && ele.title}>
                    <div
                      key={i}
                      className={`stepper-indicator-sec ${
                        this.completedFunc(i) ? "completed" : ""
                      } ${this.activeFunc(i) ? "active" : ""} ${
                        this.activeFunc(i + 1) && this.props.arrowType
                          ? "prev"
                          : ""
                      } ${this.props.arrowType2 ? "no-flex" : ""}`}
                      onClick={() => this.stepperFunc(i, ele)}
                      style={{
                        ...(this.props.arrowType && {
                          backgroundColor: this.backgroundColor(i),
                        }),
                      }}
                    >
                      {this.props.arrowType && (
                        <div
                          className="active-arrow"
                          style={{ backgroundColor: this.props.activeColor }}
                        ></div>
                      )}

                      <div
                        className={`indicator-line ${
                          this.activeFunc(i + 1) || this.completedFunc(i + 1)
                            ? "active"
                            : ""
                        }`}
                        style={{ backgroundColor: this.props.activeColor }}
                      ></div>
                      <span className="stepper-title">
                        <div
                          className="tick-icon-sec"
                          style={{
                            ...(this.activeFunc(i) &&
                              !this.props.arrowType && {
                                backgroundColor: this.backgroundColor(i),
                              }),
                            color: this.props.arrowType
                              ? this.titleColor(i)
                              : this.activeFunc(i)
                                ? "#fff"
                                : this.backgroundColor(i),
                            ...(!this.props.arrowType && {
                              borderColor: this.backgroundColor(i),
                            }),
                          }}
                        >
                          {this.completedFunc(i) && ele.icon
                            ? ele.icon
                            : `${i + 1}`}{" "}
                        </div>
                        {this.activeFunc(i) &&
                          this.props.arrowType2 &&
                          this.props.arrowType && (
                            <div
                              className="txt-sec"
                              style={{
                                color: this.titleColor(i),
                              }}
                            >
                              {ele && ele.title}
                            </div>
                          )}

                        {!this.props.arrowType2 && (
                          <div
                            className="txt-sec"
                            style={{
                              color: this.titleColor(i),
                            }}
                          >
                            {ele && ele.title}
                          </div>
                        )}
                      </span>
                    </div>
                  </Tooltip>
                ) : (
                  <div
                    key={i}
                    className={`stepper-indicator-sec ${
                      this.completedFunc(i) ? "completed" : ""
                    } ${this.activeFunc(i) ? "active" : ""} ${
                      this.activeFunc(i + 1) && this.props.arrowType
                        ? "prev"
                        : ""
                    } ${this.props.arrowType2 ? "no-flex" : ""}`}
                    onClick={() => this.stepperFunc(i, ele)}
                    style={{
                      ...(this.props.arrowType && {
                        backgroundColor: this.backgroundColor(i),
                      }),
                    }}
                  >
                    {this.props.arrowType && (
                      <div
                        className="active-arrow"
                        style={{ backgroundColor: this.props.activeColor }}
                      ></div>
                    )}

                    <div
                      className={`indicator-line ${
                        this.activeFunc(i + 1) || this.completedFunc(i + 1)
                          ? "active"
                          : ""
                      }`}
                      style={{ backgroundColor: this.props.activeColor }}
                    ></div>
                    <span className="stepper-title">
                      <div
                        className="tick-icon-sec"
                        style={{
                          ...(this.activeFunc(i) &&
                            !this.props.arrowType && {
                              backgroundColor: this.backgroundColor(i),
                            }),
                          color: this.props.arrowType
                            ? this.titleColor(i)
                            : this.activeFunc(i)
                              ? "#fff"
                              : this.backgroundColor(i),
                          ...(!this.props.arrowType && {
                            borderColor: this.backgroundColor(i),
                          }),
                        }}
                      >
                        {this.completedFunc(i) && ele.icon
                          ? ele.icon
                          : `${i + 1}`}{" "}
                      </div>
                      {this.activeFunc(i) &&
                        this.props.arrowType2 &&
                        this.props.arrowType && (
                          <div
                            className="txt-sec"
                            style={{
                              color: this.titleColor(i),
                            }}
                          >
                            {ele && ele.title}
                          </div>
                        )}

                      {!this.props.arrowType2 && (
                        <div
                          className="txt-sec"
                          style={{
                            color: this.titleColor(i),
                          }}
                        >
                          {ele && ele.title}
                        </div>
                      )}
                    </span>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }
}
